import React from 'react';
import Button from '@atlaskit/button';
import InlineDialog from '@atlaskit/inline-dialog';
import OverviewIcon from '@atlaskit/icon/glyph/overview';

import { useOpenableController } from '@/controllers';
import { helpDialogWithScroll } from '@/styles';
import { FCC } from '@/utils/types';

import * as styles from './styles';

type DetailButtonDialogProps = {
  title: React.ReactNode;
  isLoading?: boolean;
  testId?: string;
  css?: any;
} & Pick<React.HTMLProps<HTMLDivElement>, 'className'>;

const DetailButtonDialog: FCC<DetailButtonDialogProps> = ({
  title,
  isLoading,
  testId,
  className,
  children,
  css = '',
}) => {
  const modal = useOpenableController();

  return (
    <span className={className} css={css} data-testid={testId}>
      <InlineDialog
        onClose={modal.onClose}
        content={<div css={helpDialogWithScroll}>{children}</div>}
        isOpen={modal.isOpen}
        placement="bottom-end"
        testId={`${testId}-content`}
      >
        <span css={[styles.main]}>
          <Button
            appearance="subtle-link"
            spacing="none"
            isDisabled={isLoading}
            onClick={modal.onToggle}
            iconBefore={
              <span css={styles.buttonIcon}>
                <OverviewIcon label="" size="small" />
              </span>
            }
          >
            {title}
          </Button>
        </span>
      </InlineDialog>
    </span>
  );
};

export default DetailButtonDialog;
